import React, { useState } from 'react'
import { H3 } from '@blueprintjs/core'
import FadeIn from 'react-fade-in'

const PersonalQuestion = ({ reference, question, answers, handleResponses }) => {

    const [selected, setSelected] = useState('')

    const handleAnswer = e => {
        handleResponses(e)
        setSelected(e.target.value)
    }

    return (
        <FadeIn>
            <H3 className='text-center'>{question}</H3>
            <div className="personalAnswersContainer">
                {answers.map((answer, i) => (
                    <button
                        key={i}
                        name={reference}
                        value={answer}
                        onClick={handleAnswer}
                        className={selected === answer ? 'selectedVote' : 'notSelectedVote'}
                    >
                        {answer}
                    </button>
                ))}
            </div>
        </FadeIn>
    )
}

export default PersonalQuestion
